/* eslint-disable */

function Filters(onclick) {

    const result = document.querySelector('.header-result');
    const result_title = result.querySelector('h2');
    const result_filters_choices = result.querySelector('.filters .choices');
    const template = document.getElementById("tpl-result-card");

    this.reset = () => { };
    this.click = () => { };

    const inputs = document.querySelectorAll(".filters input:not(.all)");
    const inputs_all = document.querySelectorAll(".filters input.all");
    const filters = document.querySelector('.filters');
    const categories = document.querySelector('.categories');
    const inputs_categories = categories ? categories.querySelectorAll('input') : [];
    const btn_reset = result.querySelector(".btn-reset");
    let btn_choices;
    let isOPen = true;


    const datepicker = document.getElementById("datepicker");


    btn_reset.addEventListener('click', () => {
        //result_filters_choices.innerHTML = "";
        btn_choices.forEach(btn => {
            document.getElementById(btn.dataset.id).checked = false;
        })
      //  btn_reset.classList.remove("show");
        inputs_all.forEach(input => input.checked = false);
        this.reset();
    });

    [...inputs, ...inputs_categories].forEach(input => {
        input.onchange = () => {
            if (!input.checked) {
                const modal = input.closest(".modal");
                if (modal) modal.querySelector(".all").checked = false;
            }
            this.click(false);
        }
        input.checked = false;
    })

    inputs_all.forEach(input => {
        input.addEventListener("click", () => {
            const modal = input.closest(".modal");
            modal.querySelectorAll("input:not(.all)").forEach((e) => {
                //const id = e.id;
                e.checked = input.checked;
            })
            this.click(false);
        });
        input.checked = false;
    })

    const btns = document.querySelectorAll(".filters button");

    const close = sel => {
        //isOPen = false;
        btns.forEach(btn => {
            if (sel != btn && btn.classList.contains("open")) {
                hide(btn);
            }
        });
    }

    const hide = (btn) => {
        const id = btn.getAttribute("aria-controls");
        //isOPen = false;
        btn.classList.remove("open");

        if (!id) {
            if (typeof onclick == "function") onclick(btn);
        } else {
            const modal = document.getElementById(id);
            const modal_inner = modal.querySelector(".inner");
            modal.style.setProperty('--height', `${modal_inner.clientHeight}px`);
            modal.classList.add("close");
            modal.addEventListener("animationend", () => {
                btn.classList.remove("open");
                modal.classList.remove("open");
                modal.classList.remove("close");
            }, { once: true })
        }
    }

    const show = (btn) => {
        const id = btn.getAttribute("aria-controls");

        // isOPen = true;

        btn.classList.add("open");

        if (!id) {
            if (typeof onclick == "function") onclick(btn);
        } else {
            const modal = document.getElementById(id);
            const modal_inner = modal.querySelector(".inner");
            modal.classList.add("open");
            modal.style.left = `${btn.offsetLeft}px`;
            modal.style.setProperty('--height', `${modal_inner.offsetHeight}px`);
            modal.querySelector("ul").scrollTo(0, 0);
        }
    }

    btns.forEach(btn => {
        btn.onclick = () => {
            if (!btn.getAttribute("aria-controls")) {
                //  close(btn);
                //  if (typeof onclick == "function") onclick(btn);
            } else { }
            close(btn);
            btn.classList.contains("open") ? hide(btn) : show(btn);

        }
    });

    filters.onmouseenter = () => {
        isOPen = false;
    }

    filters.onmouseleave = () => {
        isOPen = true;
    }

    window.addEventListener("scroll", (e) => {
        isOPen && close(null);
    })

    window.addEventListener("click", (e) => {
        if (!filters.contains(e.target)) {
            isOPen && close(null);
            btns.forEach(btn => {
                btn.classList.remove('open');
            });
        }
    })

    this.close = () => {
        close(null);
    }

    function dateFormat(value) {
        let arr = value.split('-');
        return `${arr[2]}/${arr[1]}/${arr[0]}`;
    }

    this.display = (total) => {
        result.classList[total === 0 ? "add" : "remove"]("error");

        result_title.innerHTML = `<span class="value">${total}</span> ${total > 1 ? result_title.dataset.multi : result_title.dataset.single}`;

        // Affiche les filters dans résultats
        result_filters_choices.innerHTML = "";
        const filtersChecked = filters.querySelectorAll("input:not(.all):checked");
        const categoriesChecked = categories ? categories.querySelectorAll("input:checked") : [];
        [...filtersChecked, ...categoriesChecked].forEach(input => {
            const label = input.nextElementSibling;
            const clone = template.content.cloneNode(true);
            const btn = clone.querySelector("button");
            clone.querySelector(".name").innerText = label.textContent;
            btn.value = input.value;
            btn.name = input.name;
            btn.dataset["id"] = input.id;
            result_filters_choices.appendChild(clone);
        })

        // if datepicker
        let dates = [];
        if (datepicker) {
            const arr = datepicker.value.split(" - ");
            const lang = document.querySelector("html").lang;

            if (arr.length > 1) {
                dateFormat(arr[0]);
                if (arr[0] === arr[1]) {
                    if (lang === "fr-FR") dates.push(`Le ${dateFormat(arr[0])}`)
                    if (lang === "en-US") dates.push(`On ${dateFormat(arr[0])}`)
                    if (lang === "tr-TR") dates.push(`${dateFormat(arr[0])} tarihinde`)
                } else {
                    if (lang === "fr-FR") dates.push(`Du ${dateFormat(arr[0])} au ${dateFormat(arr[1])}`)
                    if (lang === "en-US") dates.push(`From ${dateFormat(arr[0])} to ${dateFormat(arr[1])}`)
                    if (lang === "tr-TR") dates.push(`${dateFormat(arr[0])} tarihinden ${dateFormat(arr[1])} tarihine kadar`)
                }
            }
        }
        dates.forEach(input => {
            const clone = template.content.cloneNode(true);
            const btn = clone.querySelector("button");
            clone.querySelector(".name").innerText = input;
            btn.value = input;
            btn.name = "datepicker";
            btn.dataset["id"] = "datepicker";
            result_filters_choices.appendChild(clone);
        })
        btn_choices = result_filters_choices.querySelectorAll("button");

        btn_choices.forEach(btn => {
            btn.onclick = () => {
                document.getElementById(btn.dataset.id).checked = false;
                this.click(btn.name === "datepicker" ? true : false);
            }
        })
        btn_choices.length ? result.classList.add("show") : result.classList.remove("show");
        btn_choices.length ? btn_reset.classList.add("show") : btn_reset.classList.remove("show");
    }
};

export default Filters;